<template>
    <div class="socket socket--nav">
        <nav>
            <ul>
                <li><a :href="contactUrl"><translate>Kontakt</translate></a></li>
                <li><a :href="termsandconditionsUrl"><translate>AGB</translate></a></li>
                <li><a :href="imprintUrl"><translate>Impressum</translate></a></li>
                <li><a :href="disclaimerUrl"><translate>Datenschutz</translate></a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'SocketNav',
    computed: {
        disclaimerUrl() {
            return this.$language.current === 'en' ? this.$page.props.urls.disclaimer_en: this.$page.props.urls.disclaimer_de;
        },
        termsandconditionsUrl() {
            return this.$language.current === 'en' ? this.$page.props.urls.termsandconditions_en: this.$page.props.urls.termsandconditions_de;
        },
        imprintUrl() {
            return this.$language.current === 'en' ? this.$page.props.urls.imprint_en: this.$page.props.urls.imprint_de;
        },
        contactUrl() {
            return this.$language.current === 'en' ? this.$page.props.urls.contact_en: this.$page.props.urls.contact_de;
        },
    }
};
</script>
